// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"G8-z"};